export default __webpack_public_path__ + "static/icon-13-6-f182fbe9edb1e1090e4242bc02e37e70.png";